<template lang="pug">
  div(@click="clickOutside")
    v-container.pt-6(fluid)
      div.py-5
        v-row.mb-2(no-gutters align="center")
          v-col.ml-3
            .text-2l.font-semibold.neutral700--text Review Invites
      v-divider
      v-form(ref="form")
        v-data-table(:headers="headers" :items="stocks" hide-default-footer disable-sort fixed-header height="50vh" loader-height="2" :items-per-page="-1")
          //- Number
          //- Name
          template(v-slot:item.name="{ item }")
            div.item-custom-style(@click.stop="clickRow(item)")
              v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.name" placeholder="Insert Customer Name" outlined dense height="48" :rules="rules.has_quantity" hide-details )
              div(v-else-if="item.name") {{ item.name }}
          //- Quantity
          template(v-slot:item.phone="{ item }")
            div.item-custom-style(@click.stop="clickRow(item)")
              v-text-field.text-sm.round-xl(v-if="item.editable" v-model="item.phone" placeholder="Format: 0192232222" outlined dense height="48" type="number" :rules="rules.has_quantity" hide-details)
              div(v-else-if="item.phone") {{ item.phone }}
          //- No data
          template(v-slot:no-data)
            div
    v-footer.white(app inset padless elevation="3")
      v-container.px-10(fluid)
        div.d-flex.align-center
          v-spacer
          v-btn.button-md.underline.mr-4(text @click.stop="goBack") {{ $t('cancel') }}
          v-btn.button-md(color="neutral700" depressed dark :loading="isLoading" @click.stop="saveData") {{ $t('save') }}
        //- div.d-flex.align-center
          v-spacer
          y-button.mr-4(:label="$t('cancel')" underline color="neutral700" size="md" button-class="px-0" @click.stop="goBack")
          y-button(:label="$t('save')" text-color="neutral100" color="neutral700" size="md" dark :loading="isLoading" @click.stop="saveData")
  </template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
//import MedicationSoldByDropdown from '@/components/clinic/inventory/MedicationSoldByDropdown.vue'
//import MedicationStockDropdown from '@/components/clinic/inventory/MedicationStockDropdown.vue'

export default {
  name: 'StockUpdate',
  // components: { MedicationSoldByDropdown, MedicationStockDropdown },
  props: ['id'],
  data() {
    return {
      isLoading: false,
      showInvoicePicker: false,
      stockInvoiceNo: null,
      invoiceDateField: null,
      selectedInvoiceDate: null,
      seller: {},
      stocks: [{ editable: true, name: 'please insert name', phone: 'insert phone' }],
      headers: [
        { text: 'Name', value: 'name'},
        { text: 'Phone Number', value: 'phone', width: '30%' },
        { text: '', value: 'action', width: 72 },
      ],
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
      },
    }
  },
  computed: {
    ...mapState('user', ['user', 'member']),
    ...mapGetters({ company: 'getCompany' }),
  },
  methods: {
    ...mapActions(['showMessage']),
    clickRow (item) {
      this.closeEditable()
      item.editable = true
    },
    clickOutside () {
      this.closeEditable()
      const notFullRow = this.stocks.find(f => !f.name || !f.phone )
      const emptyRow = this.stocks.find(f => !f.name && !f.phone)
      if (!emptyRow && !notFullRow) {
        this.stocks.push({ editable: false })
        console.log(this.stocks)
      }
    },
    closeEditable () {
      return this.stocks.map(m => {
        if (m.name && m.phone) {
          m.editable = false
        } else if (!m.name && !m.phone) {
          m.editable = false
        }
      })
    },
    isCompletedItem (item) {
      if (!item.editable && item.name && item.phone) {
        return true
      }
      return false
    },
    async saveData () {
      console.log(this.stocks)
      await this.closeEditable()
      if (!this.$refs.form.validate() || this.stocks.find(f => f.editable)) {
        this.showMessage(['error', this.$t('error_message.please_fill_out_all_required')])
        return
      }
      this.isLoading = true
      try {
        await this.stocks.forEach(async stock => {
          if (!stock.name || !stock.phone ) { return }
          let data = {
            name: stock.name,
            phone: stock.phone,
           
          }
          await this.$axios.post(`/reviews/${this.company.slug}/invites/`, data)
        })
        this.isLoading = false
        this.goBack()
      } catch {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isLoading = false
      }    
    },
    deleteItem (idx) {
      this.stocks.splice(idx, 1)
    },
    goBack () {
      this.$router.push('/admin/review/review')
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-width {
  width: 50px !important;
}
.item-custom-style {
  display:grid;
  align-content: center;
  height: 60px;
  cursor: pointer;
}
::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  } 
  .error--text {
    color: var(--v-danger500) !important;
    fieldset {
      border-color: var(--v-danger500);
    }
  }
  .date-field .v-input__append-inner {
    margin-top: 12px !important;
  }
}
</style>